import './App.css';
import Login from './Pages/Login';
import Home from './Pages/Home';  // You'll need to create this component
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Category from './Pages/Category';
import CategoryEdit from './Pages/CategoryEdit';
import SubCategory from './Pages/SubCategory';
import SubCategoryEdit from './Pages/SubCategoryEdit';
import Service from './Pages/Service';
import City from './Pages/City';
import User from './Pages/User';
import AppEditor from './Pages/AppEditor';
import AutoHome from './Pages/AutoHome';
import Orders from './Pages/Orders';
import OrderDetails from './Pages/OrderDetails';
import AdminOrderCreate from './Pages/AdminOrderCreate';
import Contractor from './Pages/Contractor';
import ContractorDetails from './Pages/ContractorDetails';
import InsuranceSlabs from './Pages/InsuranceSlabs';
import Verification from './Pages/Verification';
import VerificationDetails from './Pages/VerificationDetails';
import Promo from './Pages/Promo';
import Combo from './Pages/Combo';
import ServiceEdit from './Pages/ServiceEdit';
import ServiceDetails from './Pages/ServiceDetails';
import ServiceContentSections from './Pages/ServiceContentSections';
import ServiceContentSectionsLanding from './Pages/ServiceContentSectionsLanding';
import Blog from './Pages/Blog';
import BlogEdit from './Pages/BlogEdit';
import CallMasking from './Pages/CallMasking';
import Jobs from './Pages/Jobs';
import JobDetails from './Pages/JobDetails';
import B2BDashboard from './Pages/B2BDashboard';
import Organizations from './Pages/Organizations';
import OrganizationEdit from './Pages/OrganizationEdit';

function App() {
  // Helper function to check if user is authenticated
  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };

  // Protected Route component
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/login" />;
    }
    return children;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            isAuthenticated() ? <Navigate to="/home" /> : <Login />
          } />
          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/categories" element={
            <ProtectedRoute>
              <Category />
            </ProtectedRoute>
          } />
          <Route path="/categories/:id" element={
            <ProtectedRoute>
              <CategoryEdit />
            </ProtectedRoute>
          } />
          <Route path="/subcategories" element={
            <ProtectedRoute>
              <SubCategory />
            </ProtectedRoute>
          } />
          <Route path="/subcategories/:id" element={
            <ProtectedRoute>
              <SubCategoryEdit />
            </ProtectedRoute>
          } />
          <Route path="/services" element={
            <ProtectedRoute>
              <Service />
            </ProtectedRoute>
          } />
          <Route path="/services/view/:id" element={
            <ProtectedRoute>
              <ServiceDetails />
            </ProtectedRoute>
          } />
          <Route path="/services/:id" element={
            <ProtectedRoute>
              <ServiceEdit />
            </ProtectedRoute>
          } />
          <Route path="/services/:serviceId/content-sections" element={
            <ProtectedRoute>
              <ServiceContentSections />
            </ProtectedRoute>
          } />
          <Route path="/service-content-sections" element={
            <ProtectedRoute>
              <ServiceContentSectionsLanding />
            </ProtectedRoute>
          } />
          <Route path="/cities" element={
            <ProtectedRoute>
              <City />
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <User />
            </ProtectedRoute>
          } />
          <Route path="/app-editor" element={
            <ProtectedRoute>
              <AppEditor />
            </ProtectedRoute>
          } />
          <Route path="/auto-home" element={
            <ProtectedRoute>
              <AutoHome />
            </ProtectedRoute>
          } />
          <Route path="/orders" element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          } />
          <Route path="/orders/new" element={
            <ProtectedRoute>
              <AdminOrderCreate />
            </ProtectedRoute>
          } />
          <Route path="/orders/:id" element={
            <ProtectedRoute>
              <OrderDetails />
            </ProtectedRoute>
          } />
          <Route path="/contractors" element={
            <ProtectedRoute>
              <Contractor />
            </ProtectedRoute>
          } />
          <Route path="/contractors/:id" element={
            <ProtectedRoute>
              <ContractorDetails />
            </ProtectedRoute>
          } />
          <Route path="/insurance-slabs" element={
            <ProtectedRoute>
              <InsuranceSlabs />
            </ProtectedRoute>
          } />
          <Route path="/verifications" element={
            <ProtectedRoute>
              <Verification />
            </ProtectedRoute>
          } />
          <Route path="/verifications/:id" element={
            <ProtectedRoute>
              <VerificationDetails />
            </ProtectedRoute>
          } />
          <Route path="/promo" element={
            <ProtectedRoute>
              <Promo />
            </ProtectedRoute>
          } />
          <Route path="/combos" element={
            <ProtectedRoute>
              <Combo />
            </ProtectedRoute>
          } />
          <Route path="/blogs" element={
            <ProtectedRoute>
              <Blog />
            </ProtectedRoute>
          } />
          <Route path="/blogs/:id" element={
            <ProtectedRoute>
              <BlogEdit />
            </ProtectedRoute>
          } />
          <Route path="/call-masking" element={
            <ProtectedRoute>
              <CallMasking />
            </ProtectedRoute>
          } />
          <Route path="/jobs" element={
            <ProtectedRoute>
              <Jobs />
            </ProtectedRoute>
          } />
          <Route path="/jobs/:id" element={
            <ProtectedRoute>
              <JobDetails />
            </ProtectedRoute>
          } />
          <Route path="/b2b" element={
            <ProtectedRoute>
              <B2BDashboard />
            </ProtectedRoute>
          } />
          <Route path="/organizations" element={
            <ProtectedRoute>
              <Organizations />
            </ProtectedRoute>
          } />
          <Route path="/organizations/:id" element={
            <ProtectedRoute>
              <OrganizationEdit />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/home" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;